import { styled, Tooltip, TooltipProps } from "@mui/material";

export function TooltipStyled(props: TooltipProps) {
  const TooltipStyled = styled((props: TooltipProps) => (
    <Tooltip {...props}>{props.children}</Tooltip>
  ))(({ theme }) => ({
    "& .base-Popper-root": {
      "& .MuiTooltip-tooltip": {
        borderRadius: "8px",
        padding: "8px 12px",
        fontSize: "0.875rem",
        fontFamily: "Roboto",
        boxShadow: "0px -4px 6px -1px rgba(0, 0, 0, 0.10) !important;",
        color: theme.palette.text.primary,
        border:
          theme.palette.mode === "light"
            ? "1px solid rgba(21, 21, 21, 0.20) !important;"
            : "1px solid rgba(255, 255, 255, .2)",
        backgroundColor:
          theme.palette.mode === "dark" ? theme.palette.grey[500] : theme.palette.grey[500],
      },
    },
  }));

  return <TooltipStyled {...props}>{props.children}</TooltipStyled>;
}
